import React from "react"
import "./style.scss"

export default function loading() {
  return (
    <div className="comp-loading">
      <div className="item-1"></div>
      <div className="item-2"></div>
    </div>
  )
}
